module.exports = __webpack_public_path__ + "img/overview_look_logo.58f6237a.png";